(function() {
  let blinkInterval = null;
  let originalFavicon = null;
  let cachedBadgeDataURL = null;
  let lastCheckedCount = 0;

  function getFaviconLink() {
    return document.querySelector("link[rel*='icon']");
  }

  // CHẮC CHẮN LƯU GỐC: Lấy thuộc tính href gốc ngay từ đầu và giữ nguyên giá trị chuỗi này
  const faviconEl = getFaviconLink();
  if (faviconEl) {
    // Ép kiểu lấy URL tuyệt đối để trình duyệt không bị loạn khi gán lại
    originalFavicon = faviconEl.href; 
  }

  function generateFaviconBadge(count, callback) {
    if (count <= 0 || !originalFavicon) return;
    
    if (count === lastCheckedCount && cachedBadgeDataURL) {
      return callback(cachedBadgeDataURL);
    }

    lastCheckedCount = count;
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = originalFavicon; // Luôn dùng link gốc để làm phôi vẽ
    
    img.onload = function() {
      const canvas = document.createElement('canvas');
      canvas.width = img.width || 32;
      canvas.height = img.height || 32;
      const ctx = canvas.getContext('2d');
      
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      
      const radius = canvas.width * 0.35; 
      const x = radius - (canvas.width * 0.01); 
      const y = canvas.height - radius + (canvas.width * 0.01); 
      
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, 2 * Math.PI, false);
      ctx.fillStyle = '#FF0000'; 
      ctx.fill();
      
      ctx.fillStyle = '#FFFFFF'; 
      ctx.font = `bold ${canvas.width * 0.55}px Arial, sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      
      ctx.fillText(count > 9 ? '9+' : count, x, y);
      
      cachedBadgeDataURL = canvas.toDataURL('image/png');
      callback(cachedBadgeDataURL);
    };
  }

  function startBlinking(count) {
    stopBlinking(); 
    
    generateFaviconBadge(count, (badgeUrl) => {
      // ĐIỀU KIỆN CHẶN: Nếu trong lúc API chạy xong mà người dùng đã mở lại tab, hủy luôn không chạy nữa
      if (!document.hidden) return;

      let showBadge = false;
      
      blinkInterval = setInterval(() => {
        const faviconEl = getFaviconLink();
        if (!faviconEl) return;
        
        showBadge = !showBadge;
        faviconEl.href = showBadge ? badgeUrl : originalFavicon;
      }, 1500);
    });
  }

  function stopBlinking() {
    if (blinkInterval) {
      clearInterval(blinkInterval);
      blinkInterval = null;
    }
    const faviconEl = getFaviconLink();
    // Trả lại đúng đường dẫn ảnh gốc ban đầu đã lưu
    if (faviconEl && originalFavicon) {
      faviconEl.href = originalFavicon;
    }
  }

  document.addEventListener("visibilitychange", function() {
    if (document.hidden) {
      fetch('/cart.js')
        .then(response => response.ok ? response.json() : null)
        .then(cart => {
          if (cart && cart.item_count > 0) {
            startBlinking(cart.item_count);
          }
        })
        .catch(err => console.warn("Cart fetch failed:", err));
    } else {
      stopBlinking();
    }
  });
})();
